import { useState } from 'react';
import { useClassroomApi } from '../api/classroomApi';

export const useCreateClassroom = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { createClassroom: apiCreateClassroom } = useClassroomApi();

  const createClassroom = async (classroomData) => {
    setLoading(true);
    setError(null);
    
    const { data, error: apiError } = await apiCreateClassroom(classroomData);
    
    setLoading(false);
    
    if (apiError) {
      setError(apiError);
      return { success: false, error: apiError };
    }
    
    return { success: true, data };
  };

  return {
    createClassroom,
    loading,
    error,
  };
};